/*
 *
 * prefecture selector
 *
 */
import React from 'react';
import CustomSelectorBase from './CustomSelectorBase';
import PropTypes from 'prop-types';

const OPTION_DEFAULT = '都道府県';

const PrefSelector = (props) => {
  const prefList = [
    OPTION_DEFAULT,
    '北海道',
    '青森県',
    '岩手県',
    '宮城県',
    '秋田県',
    '山形県',
    '福島県',
    '茨城県',
    '栃木県',
    '群馬県',
    '埼玉県',
    '千葉県',
    '東京都',
    '神奈川県',
    '新潟県',
    '富山県',
    '石川県',
    '福井県',
    '山梨県',
    '長野県',
    '岐阜県',
    '静岡県',
    '愛知県',
    '三重県',
    '滋賀県',
    '京都府',
    '大阪府',
    '兵庫県',
    '奈良県',
    '和歌山県',
    '鳥取県',
    '島根県',
    '岡山県',
    '広島県',
    '山口県',
    '徳島県',
    '香川県',
    '愛媛県',
    '高知県',
    '福岡県',
    '佐賀県',
    '長崎県',
    '熊本県',
    '大分県',
    '宮崎県',
    '鹿児島県',
    '沖縄県',
  ];
  const prefOptions = prefList.map((str) => ({
    value: str,
    label: str,
  }));
  const value = props.value || OPTION_DEFAULT;

  const handleChange = (event) => {
    const {target} = event;
    const selectorValue = target.value;
    if (selectorValue === OPTION_DEFAULT) {
      event.target.value = '';
    }
    props.onChange(event);
  };

  return <CustomSelectorBase
    optionArray={prefOptions}
    {...props}
    value={value}
    onChange={handleChange}
  />;
};

PrefSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default PrefSelector;
